import React from 'react';

export default ({ category, capabilities, flags, onChange }) => {
    return <React.Fragment>

        <h1>{category} capabilities</h1>
        <div className="toggle-list">
            {
                capabilities.map(c =>
                    <div className="pc-toggle" key={c.Id}>
                        <div className="toggleContainer">
                            <label htmlFor={c.Id} className="pc-switcher-label">{c.Name}</label>

                            <input id={c.Id} type="checkbox"
                                   disabled={c.SystemOnly}
                                   checked={!!flags[c.Id]}
                                   onChange={e => {
                                       if(!c.SystemOnly) {
                                           onChange(c.Id, e.target.checked)
                                       }
                                   }}
                            />
                            <label htmlFor={c.Id} className="pc-switcher">
                                <span className="pc-switcher__span" data-on="On" data-off="Off"/>
                            </label>
                        </div>
                    </div>
                )}
        </div>
    </React.Fragment>
}




// WEBPACK FOOTER //
// /src/components/RestaurantView/ToggleList.js